import React from 'react';
import { motion } from 'framer-motion';
export function FloatingWhatsApp() {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Floating WhatsApp Button',
        content_category: 'WhatsApp CTA'
      });
      (window as any).fbq('track', 'Contact');
    }
  };
  return <motion.a href="https://wa.me/message/C5P6OYRK3Y5EP1" target="_blank" rel="noopener noreferrer" onClick={handleClick} aria-label="Contactar por WhatsApp" initial={{
    opacity: 0,
    scale: 0,
    y: 50
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1.5,
    duration: 0.6,
    type: 'spring'
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 group" data-id="element-218">
      {/* Pulsing rings */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-219"></span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-pulse" data-id="element-220"></span>

      {/* Main button */}
      <div className="relative flex items-center justify-center w-16 h-16 md:w-[68px] md:h-[68px] rounded-full bg-[#25D366] shadow-[0_8px_24px_rgba(37,211,102,0.4)] border-2 border-mystic-gold/40 group-hover:border-mystic-gold transition-colors duration-300" data-id="element-221">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-8 h-8 md:w-9 md:h-9 fill-white" aria-hidden="true" data-id="element-222">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.158-.658.158-.99-.005-.69-2.394-1.572-2.62-1.703zm-2.59 7.156c-1.747 0-3.48-.49-4.942-1.453l-3.45.91.92-3.39a8.99 8.99 0 0 1-1.69-5.263c0-4.96 4.05-9.01 9.04-9.01 4.99 0 9.05 4.05 9.05 9.01.014 4.96-4.036 9.196-8.928 9.196zm0-19.74C9.97 4.62 4.674 9.916 4.674 16.453c0 2.106.566 4.16 1.62 5.974l-1.937 7.07 7.18-1.886a11.6 11.6 0 0 0 5.554 1.418c6.546 0 12.103-5.295 12.103-11.832-.115-6.336-5.41-11.59-12.118-11.59zM16.42 0c8.873 0 16.085 7.156 16.085 16.013 0 8.86-7.213 16.013-16.085 16.013a16.18 16.18 0 0 1-7.687-1.936L0 32.46l2.435-9.232C1.146 21.42.404 18.798.404 16.013.404 7.157 7.55 0 16.42 0z" data-id="element-223" />
        </svg>
      </div>

      {/* Tooltip */}
      <span className="hidden md:block absolute right-full top-1/2 -translate-y-1/2 mr-4 px-4 py-2 bg-mystic-dark border border-mystic-gold/40 text-mystic-ivory text-sm font-serif rounded-sm shadow-xl whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-224">
        Hablemos por WhatsApp
        <span className="absolute left-full top-1/2 -translate-y-1/2 w-0 h-0 border-l-[6px] border-l-mystic-gold/40 border-y-[6px] border-y-transparent" data-id="element-225"></span>
      </span>
    </motion.a>;
}